import { useRef, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'

import { ProfileMenu } from '@weberlo/components'

import useAuth from 'hooks/useAuth'
import useConfig from 'hooks/useConfig'

import logoutIcon from 'assets/icons/universal/log-out.svg'

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

const Profile = () => {
  const queryClient = useQueryClient()
  const { onChangeWorkspace } = useConfig()

  const { logout, user } = useAuth()

  const handleLogout = async () => {
    try {
      await logout()
      onChangeWorkspace('', '', '')
      queryClient.clear()
    } catch (err) {
      console.error(err)
    }
  }

  const anchorRef = useRef<any>(null)
  const [open, setOpen] = useState(false)
  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen)
  }

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }
    setTimeout(() => setOpen(false), 300)
  }

  const menu = [
    {
      id: 'logout',
      icon: (
        <img
          alt="logout icon"
          src={logoutIcon}
        />
      ),
      label: 'Logout',
      onClick: handleLogout,
    },
  ]

  return (
    <ProfileMenu
      open={open}
      anchorEl={null}
      handleClick={handleToggle}
      onClose={handleClose}
      menuItems={menu}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      userEmail={user?.attributes?.email || ''}
      username={user?.attributes?.name || ''}
    />
  )
}

export default Profile
